import { useState } from "react";
import { Text, TextInput } from "@mantine/core";
import { useUpdateQueryNameMutation } from "../../hooks/mutations";
import classes from "./QueryName.module.scss";

/**
 * Editable label for a query's alias. Click to edit, blur to save;
 * read-only when `canEdit` is false.
 *
 * Optimistic-update is wired in `useUpdateQueryNameMutation` so the
 * displayed alias updates immediately on save and rolls back on error.
 */
export default function QueryName({
  ruleId,
  queryId,
  initialValue,
  placeholder = "Query name",
  canEdit = true,
}) {
  const [editMode, setEditMode] = useState(false);
  const { mutate: updateQueryName } = useUpdateQueryNameMutation({ ruleId });

  const display = initialValue || placeholder;

  if (!canEdit || !editMode) {
    return (
      <Text
        className={canEdit ? classes.label : classes.labelReadOnly}
        onClick={canEdit ? () => setEditMode(true) : undefined}
      >
        {display}
      </Text>
    );
  }

  return (
    <TextInput
      defaultValue={initialValue || ""}
      placeholder={placeholder}
      variant="unstyled"
      autoFocus
      onBlur={(ev) => {
        const alias = ev.currentTarget.value;
        if (alias !== initialValue) {
          updateQueryName({ queryId, alias });
        }
        setEditMode(false);
      }}
      onKeyDown={(ev) => {
        if (ev.key === "Enter") ev.currentTarget.blur();
        if (ev.key === "Escape") setEditMode(false);
      }}
      classNames={{ input: classes.input }}
    />
  );
}
